import type { AdminPlan } from '@/contracts';

/** A plan's live price in major units — what the editor shows until it is edited. */
export const livePrice = (plan: AdminPlan) => Math.round(plan.priceMinor / 100);

/**
 * The catalogue key for each plan feature code — the codes carry dots, which a
 * nested key would swallow. An unknown code is shown raw rather than guessed.
 */
export const FEATURE_KEYS: Record<string, string> = {
  'profile.priority_visibility': 'priorityVisibility',
  'profile.video_intro': 'videoIntro',
  'opportunities.flag_interest': 'flagInterest',
  'profile.advanced_stats': 'advancedStats',
};

/**
 * The catalogue key for each policy switch's label + hint. The API stores only
 * `key` and `enabled` — the wording is a console concern, matched by key, so a
 * new switch added server-side simply needs its copy here.
 */
export const POLICY_KEYS: Record<string, string> = {
  auto_audit: 'autoAudit',
  force_seal: 'forceSeal',
  require_degrees: 'requireDegrees',
  notify_expiring: 'notifyExpiring',
};
